// extracted by mini-css-extract-plugin
module.exports = {"addAdminButton":"CompanyUsersSection_addAdminButton__TxGhD","iconButton":"CompanyUsersSection_iconButton__1RSBn"};